import useMyAccountQuery from '#hooks/queries/accounts/useMyAccountQuery';
import WeeklyCalendar from 'src/features/Calendar/WeeklyCalendar';
import WeeklyCalendarForAdmin from 'src/features/Calendar/WeeklyCalendarForAdmin';

export interface WeeklyCalenderProps {
  hasHomeNav?: boolean;
}

export function WeeklyCalendarPage() {
  const { data: account, isLoading } = useMyAccountQuery();

  if (isLoading) {
    return null;
  }

  return (
    <>{account?.isGymAdmin ? <WeeklyCalendarForAdmin /> : <WeeklyCalendar />}</>
  );
}
